module.exports = __webpack_public_path__ + "img/1490388485.c21e3fb3.jpg";